<!-- <div class="app-sidebar sidebar-shadow">
    <div class="app-header__logo">
        <div class="logo-src"></div>
        <div class="header__pane ml-auto">
            <div>
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
                    data-class="closed-sidebar">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="app-header__mobile-menu">
        <div>
            <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
    </div>
    <div class="app-header__menu">
        <span>
            <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
                <span class="btn-icon-wrapper">
                    <i class="fa fa-ellipsis-v fa-w-6"></i>
                </span>
            </button>
        </span>
    </div>
    <div class="scrollbar-sidebar">
        <div class="app-sidebar__inner">
            <ul class="vertical-nav-menu">
                <li class="app-sidebar__heading">Menu</li>
                <li class="mm-active">
                    <a href="javascript:void(0)" (click)="redirectToPage('dash')">
                        <i class="metismenu-icon pe-7s-home"></i>Dashboard
                    </a>
                </li>
                <li class="mm-active">
                    <a href="javascript:void(0)" (click)="redirectToPage('dash')">
                        <i class="metismenu-icon pe-7s-share"></i>Project
                    </a>
                </li>

                <li class="mm-active">
                    <a href="javascript:void(0)">
                        <i class="metismenu-icon pe-7s-rocket"></i>Manuals
                        <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                    </a>
                    <ul>
                        <li *ngFor="let item of projectList">
                            <a (click)="gotomanuals(item.id)">
                                <i class="metismenu-icon"></i>{{ item.name }}
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="mm-active">
                    <a href="javascript:void(0)">
                        <i class="metismenu-icon pe-7s-tools"></i>Spare Parts List
                        <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                    </a>
                    <ul>
                        <li *ngFor="let item of GetCustomersProjectList">
                            <a href="javascript:void(0)" (click)="SparePartDetailsComponent(item.id)">
                                <i class="metismenu-icon"></i>{{ item?.projects?.departments?.name }}
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="mm-active">
                    <a href="javascript:void(0)" (click)="redirectToPage('ComplaintsList')">
                        <i class="metismenu-icon pe-7s-rocket"></i>Service Call / Complaint
                    </a>
                </li>
                <li class="mm-active">
                    <a href="javascript:void(0)" (click)="redirectToPage('help')">
                        <i class="metismenu-icon pe-7s-rocket"></i>Help
                    </a>
                </li>                
            </ul>
        </div>
    </div>
</div> -->
<div class="scrollbar-sidebar"></div>